module.exports = __webpack_public_path__ + "static/beshaba-symbol-DND3_FnP-77db1f039a90ebaa770c6d4bcba14dfb.webp";